import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { TutorialDialogComponent } from '@app/components/dialogs/tutorial-dialog/tutorial-dialog.component';
import { tutorialActions } from '@app/store/tutorial/tutorial.actions';

const openTutorialDialog = createEffect(
  () => {
    const actions$ = inject(Actions);
    const dialog = inject(MatDialog);

    return actions$.pipe(
      ofType(tutorialActions.openTutorialDialog),
      tap(payload => {
        dialog.open(TutorialDialogComponent, {
          data: { gameType: payload.gameType },
          maxWidth: '900px',
        });
      }),
    );
  },
  {
    functional: true,
    dispatch: false,
  },
);

export const tutorialEffects = {
  openTutorialDialog,
};
